import { useCallback } from 'react'
import { bleService } from '../services/bleService'
import { useBleStore } from '@/state/bleStore'
import type { SensorPlacement } from '@/features/ble/types'

/**
 * React hook to access BLE connection state and actions.
 * Decoupled from BleService internals — components only see this interface.
 */
export function useBle() {
  const status = useBleStore((s) => s.status)
  const device = useBleStore((s) => s.device)
  const error = useBleStore((s) => s.error)
  const reconnectAttempt = useBleStore((s) => s.reconnectAttempt)
  const deviceOrder = useBleStore((s) => s.deviceOrder)
  const devicesById = useBleStore((s) => s.devices)
  const devices = deviceOrder.map((id) => devicesById[id]).filter(Boolean)

  const connect = useCallback(() => bleService.connect(), [])
  const disconnect = useCallback(() => bleService.disconnect(), [])
  const disconnectAll = useCallback(() => bleService.disconnectAll(), [])
  const disconnectDevice = useCallback((deviceId: string) => bleService.disconnect(deviceId), [])
  const setPlacement = useCallback(
    (deviceId: string, placement: SensorPlacement) => bleService.setPlacement(deviceId, placement),
    [],
  )

  return {
    status,
    device,
    error,
    reconnectAttempt,
    devices,
    connect,
    disconnect,
    disconnectAll,
    disconnectDevice,
    setPlacement,
  }
}
